export default __webpack_public_path__ + "static/media/interactive-website-thumbnail.8cf0e153.png";